import React, { useState } from "react";
import { List, Card, Collapse, Typography, Row, Col, Button } from "antd";
import {
  EnhancementCase,
  EnhancementField,
} from "../../../interfaces/IEnhancement";
import { renderCommonField } from "../CommonFields";
import { EditOutlined } from "@ant-design/icons";

const { Panel } = Collapse;
const { Text } = Typography;

interface EnhancementListProps {
  cases: EnhancementCase[];
  selectedIndex: number | null;
  viewFile?: CallableFunction;
  handleDeleteList?: CallableFunction;
  handleSetDocumentUrl?: CallableFunction;
  handleOpen?: any;
  handleDownloadDocument?: CallableFunction;
  uploadedDocumentUrl?: any;
  handleDeficiencyModal?: any;
  closeDeficiencyModal?: any;
  deficiencyModal?: boolean;
  deficiencyQuestions?: any;
  previewDocumentUrl?: string;
  setDocumentName?: any;
  handleDeficiencyModalAfterSave?: any;
  isDownloadingDocument?: boolean;
  downloadingDocumentUrl?: string;
}

const EnhancementList: React.FC<EnhancementListProps> = ({
  cases,
  selectedIndex,
  viewFile,
  handleDeleteList,
  handleSetDocumentUrl,
  handleOpen,
  handleDownloadDocument,
  uploadedDocumentUrl,
  handleDeficiencyModal,
  closeDeficiencyModal,
  deficiencyModal,
  deficiencyQuestions,
  previewDocumentUrl,
  setDocumentName,
  handleDeficiencyModalAfterSave,
  isDownloadingDocument,
  downloadingDocumentUrl
}) => {
  // const [editModalVisible, setEditModalVisible] = useState(false);
  // const [selectedCase, setSelectedCase] = useState<EnhancementCase | null>(null);
  // const [selectedCaseId, setSelectedCaseId] = useState<string | null>(null);
  const renderFields = (fields: EnhancementField[]) => {
    return fields?.map((field, index) => (
      <Row key={field.id} align="middle" style={{ marginBottom: 8 }}>
        <Col span={24}>
          {field.type === "document-upload" && field.data === null ? (
            // <div style={{ marginBottom: "10px" }}>
            //   <Text>DOCUMENT: N/A</Text>
            // </div>
            <></>
          ) : (
            renderCommonField({
              field,
              index,
              isReadOnly: field.id == "uploadDoc" ? true : true,
              value: field.data,
              isFileUploadDisabled: true,
              key: "ihxEnhancementResponses",
              viewFile: viewFile,
              handleDeleteList: handleDeleteList,
              handleSetDocumentUrl: handleSetDocumentUrl,
              handleOpen: handleOpen,
              handleDownloadDocument: handleDownloadDocument,
              isDownloadingDocument: isDownloadingDocument,
              downloadingDocumentUrl: downloadingDocumentUrl,
              uploadedDocumentUrl: uploadedDocumentUrl,
              handleDeficiencyModal: handleDeficiencyModal,
              closeDeficiencyModal: closeDeficiencyModal,
              deficiencyModal: deficiencyModal,
              deficiencyQuestions: deficiencyQuestions,
              previewDocumentUrl: previewDocumentUrl,
              setDocumentName: setDocumentName,
              handleDeficiencyModalAfterSave: handleDeficiencyModalAfterSave,
            })
          )}
        </Col>
      </Row>
    ));
  };

  const filteredCases = cases?.filter((caseItem) => {
    const uploadDocNull =
      caseItem["Basic Details"]?.find((field) => field.id === "dateOfAdmission")
        ?.caseEnhancementId === null;
    return !uploadDocNull;
  });

  // const handleEdit = (caseItem: EnhancementCase) => {
  //   const caseId = caseItem["Billing Details"]?.[0]?.caseEnhancementId;
  //   setSelectedCase(caseItem);
  //   setSelectedCaseId(caseId?.toString() || null);
  //   setEditModalVisible(true);
  // };

  return (
    <List
    grid={{ gutter: 16, column: 1 }}
    dataSource={filteredCases}
    renderItem={(item, index) => (
      <List.Item>
        <Card
          title={`Enhancement-${filteredCases?.length - index}`} // Reverse the enhancement number
          style={{ cursor: "pointer", backgroundColor: "white" }}
          // extra={
          //   <Button
          //     icon={<EditOutlined />}
          //     onClick={() => handleEdit(item)}
          //     type="primary"
          //   >
          //     Edit
          //   </Button>
          // }
        >
          <Collapse defaultActiveKey={["1"]}>
            <Panel header="Basic Details" key="1">
              {renderFields(item["Basic Details"])}
            </Panel>
            <Panel header="Billing Details" key="2">
              {renderFields(item["Billing Details"])}
            </Panel>
          </Collapse>
        </Card>
      </List.Item>
    )}
  />
  
  );
};

export default EnhancementList;
